import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SharedLayout from "./Components/SharedLayout";
import Error from "./Components/Error";
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import '../src/input.css';
import Services from "./Pages/Services";
import Properties from "./Pages/Properties";
import PropertyDetails from "./Pages/PropertyDetails";


const App = () => {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<SharedLayout />}>
          <Route index element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/properties" element={<Properties /> } />
          <Route path="/properties/:id" element={<PropertyDetails />} />
        </Route>
        <Route path="*" element={<Error />} />
      </Routes>
    </Router>
  );
};

export default App;
